interface Rolemodels2026Props {
	lang: string
}

const Rolemodels2026: React.FC<Rolemodels2026Props> = (props: Rolemodels2026Props) => {
	return (<h1>{props.lang==='nl' ? 'Rolmodellen' : 'Rolemodels'}</h1>)
}

export default Rolemodels2026